/* eslint-disable no-dupe-keys */
export default {
  idle_fees: {
    name: '占位费规则',
    // 属性（一般与对象内容匹配）
    prop: {
      charge_station: '充电站',
      price: '单价',
      free_minutes: '免费时长',
      cost_limit: '收费上限',
      metering_period: '收费周期',
      allow_relief: '允许减免',
      charging_periods: '收费时间段',
      charging_equipment_type: '桩电源类型',
      description: '占位描述',
      created_at: '创建时间',
      updated_at: '更新时间',
      charging_periods: '收费时间段'
    },
    // Enum的属性
    charging_equipment_types: {
      all_equipment: '所有电源',
      dc_equipment: '直流电源'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      idle_fee_bills: '账单记录'
    },
    // 标题
    titles: {
      base_info: '基本信息'
    },
    // 描述
    description: {
      // 规则描述
    },
    // 校验
    validates: {
      periods_has_intersaction: '收费时间段存在交集'
    }
  }
}
